import {
  DesktopDatePicker as MuiDesktopDatePicker,
  type DatePickerProps as MuiDatePickerProps,
} from '@mui/x-date-pickers'

// reason: MUI’s internal typing does not currently allow a fully generic TDate
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type DesktopDatePickerProps<TDate> = MuiDatePickerProps<any> & {
  dayOfWeekFormatter?: (date: TDate) => string
}

/**
 * DesktopDatePicker
 * A DatePicker which is allways the same for every device!
 *
 * _Please consume the correct `dayOfWeekFormatter` for showing the days of the week correctly._
 */
/**
 * Demos:
 * - [DesktopDatePicker](https://design-system.accept.cl1.intra.dhlparcel.io/?path=/docs/inputs-date--docs)
 *
 */
export function DesktopDatePicker<TDate>(props: DesktopDatePickerProps<TDate>) {
  return <MuiDesktopDatePicker {...props} />
}
